import * as S from "react";
import { g as ot, c as re } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { u as nt } from "./index-CLU0MTzP.mjs";
import { u as it } from "./useControlled-ZIJRsfP8.mjs";
import { q as ce, c as X, t as Be, v as Ke, b as We } from "./tss-DN0acMKN.mjs";
import { u as st } from "./useForkRef-C_4o__cU.mjs";
import { u as lt } from "./useEnhancedEffect-CJGo-L3B.mjs";
import { u as Fe } from "./useEventCallback-B4gn-DZo.mjs";
import { o as Se } from "./ownerDocument-CUrv0DIK.mjs";
import { e as De } from "./resolveComponentProps-DEADesT4.mjs";
import { v as ct } from "./visuallyHidden-B8J7BVSJ.mjs";
import { i as Xe } from "./isFocusVisible-CLflI_-N.mjs";
import { i as we } from "./isHostComponent-kiaBvYVo.mjs";
import { m as ae } from "./memoTheme-BzXKG_-k.mjs";
import { s as J, d as Qe, u as ut, c as pt } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { c as Ye } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { g as dt } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as I } from "./jsx-runtime-3tyXYecC.mjs";
import { u as W } from "./useSlotProps-DmbFUW3M.mjs";
function mt(e, r, n = (i, p) => i === p) {
  return e.length === r.length && e.every((i, p) => n(i, r[p]));
}
const ft = 2;
function Ze(e, r) {
  return e - r;
}
function qe(e, r) {
  const {
    index: n
  } = e.reduce((i, p, A) => {
    const L = Math.abs(r - p);
    return i === null || L < i.distance || L === i.distance ? {
      distance: L,
      index: A
    } : i;
  }, null) ?? {};
  return n;
}
function he(e, r) {
  if (r.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let i = 0; i < n.changedTouches.length; i += 1) {
      const p = n.changedTouches[i];
      if (p.identifier === r.current)
        return {
          x: p.clientX,
          y: p.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function Le(e, r, n) {
  return (e - r) * 100 / (n - r);
}
function bt(e, r, n) {
  return (n - r) * e + r;
}
function gt(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), i = n[0].split(".")[1];
    return (i ? i.length : 0) + parseInt(n[1], 10);
  }
  const r = e.toString().split(".")[1];
  return r ? r.length : 0;
}
function vt(e, r, n) {
  const i = Math.round((e - n) / r) * r + n;
  return Number(i.toFixed(gt(r)));
}
function _e({
  values: e,
  newValue: r,
  index: n
}) {
  const i = e.slice();
  return i[n] = r, i.sort(Ze);
}
function ye({
  sliderRef: e,
  activeIndex: r,
  setActive: n
}) {
  var p, A, L;
  const i = Se(e.current);
  (!((p = e.current) != null && p.contains(i.activeElement)) || Number((A = i == null ? void 0 : i.activeElement) == null ? void 0 : A.getAttribute("data-index")) !== r) && ((L = e.current) == null || L.querySelector(`[type="range"][data-index="${r}"]`).focus()), n && n(r);
}
function ke(e, r) {
  return typeof e == "number" && typeof r == "number" ? e === r : typeof e == "object" && typeof r == "object" ? mt(e, r) : !1;
}
const ht = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, yt = (e) => e;
let xe;
function Ge() {
  return xe === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? xe = CSS.supports("touch-action", "none") : xe = !0), xe;
}
function kt(e) {
  const {
    "aria-labelledby": r,
    defaultValue: n,
    disabled: i = !1,
    disableSwap: p = !1,
    isRtl: A = !1,
    marks: L = !1,
    max: h = 100,
    min: d = 0,
    name: C,
    onChange: P,
    onChangeCommitted: Q,
    orientation: oe = "horizontal",
    rootRef: Ce,
    scale: ue = yt,
    step: N = 1,
    shiftStep: ne = 10,
    tabIndex: pe,
    value: Te
  } = e, M = S.useRef(void 0), [j, Z] = S.useState(-1), [Ue, H] = S.useState(-1), [de, me] = S.useState(!1), ee = S.useRef(0), [O, F] = it({
    controlled: Te,
    default: n ?? d,
    name: "Slider"
  }), c = P && ((t, a, o) => {
    const l = t.nativeEvent || t, f = new l.constructor(l.type, l);
    Object.defineProperty(f, "target", {
      writable: !0,
      value: {
        value: a,
        name: C
      }
    }), P(f, a, o);
  }), u = Array.isArray(O);
  let y = u ? O.slice().sort(Ze) : [O];
  y = y.map((t) => t == null ? d : ce(t, d, h));
  const U = L === !0 && N !== null ? [...Array(Math.floor((h - d) / N) + 1)].map((t, a) => ({
    value: d + N * a
  })) : L || [], E = U.map((t) => t.value), [q, $] = S.useState(-1), T = S.useRef(null), k = st(Ce, T), te = (t) => (a) => {
    var l;
    const o = Number(a.currentTarget.getAttribute("data-index"));
    Xe(a.target) && $(o), H(o), (l = t == null ? void 0 : t.onFocus) == null || l.call(t, a);
  }, Re = (t) => (a) => {
    var o;
    Xe(a.target) || $(-1), H(-1), (o = t == null ? void 0 : t.onBlur) == null || o.call(t, a);
  }, fe = (t, a) => {
    const o = Number(t.currentTarget.getAttribute("data-index")), l = y[o], f = E.indexOf(l);
    let s = a;
    if (U && N == null) {
      const w = E[E.length - 1];
      s > w ? s = w : s < E[0] ? s = E[0] : s = s < l ? E[f - 1] : E[f + 1];
    }
    if (s = ce(s, d, h), u) {
      p && (s = ce(s, y[o - 1] || -1 / 0, y[o + 1] || 1 / 0));
      const w = s;
      s = _e({
        values: y,
        newValue: s,
        index: o
      });
      let R = o;
      p || (R = s.indexOf(w)), ye({
        sliderRef: T,
        activeIndex: R
      });
    }
    F(s), $(o), c && !ke(s, O) && c(t, s, o), Q && Q(t, s);
  }, Ie = (t) => (a) => {
    var o;
    if (N !== null) {
      const l = Number(a.currentTarget.getAttribute("data-index")), f = y[l];
      let s = null;
      (a.key === "ArrowLeft" || a.key === "ArrowDown") && a.shiftKey || a.key === "PageDown" ? s = Math.max(f - ne, d) : ((a.key === "ArrowRight" || a.key === "ArrowUp") && a.shiftKey || a.key === "PageUp") && (s = Math.min(f + ne, h)), s !== null && (fe(a, s), a.preventDefault());
    }
    (o = t == null ? void 0 : t.onKeyDown) == null || o.call(t, a);
  };
  lt(() => {
    var t;
    i && T.current.contains(document.activeElement) && ((t = document.activeElement) == null || t.blur());
  }, [i]), i && j !== -1 && Z(-1), i && q !== -1 && $(-1);
  const Ae = (t) => (a) => {
    var o;
    (o = t.onChange) == null || o.call(t, a), fe(a, a.target.valueAsNumber);
  }, ie = S.useRef(void 0);
  let D = oe;
  A && oe === "horizontal" && (D += "-reverse");
  const _ = ({
    finger: t,
    move: a = !1
  }) => {
    const {
      current: o
    } = T, {
      width: l,
      height: f,
      bottom: s,
      left: w
    } = o.getBoundingClientRect();
    let R;
    D.startsWith("vertical") ? R = (s - t.y) / f : R = (t.x - w) / l, D.includes("-reverse") && (R = 1 - R);
    let g;
    if (g = bt(R, d, h), N)
      g = vt(g, N, d);
    else {
      const le = qe(E, g);
      g = E[le];
    }
    g = ce(g, d, h);
    let V = 0;
    if (u) {
      a ? V = ie.current : V = qe(y, g), p && (g = ce(g, y[V - 1] || -1 / 0, y[V + 1] || 1 / 0));
      const le = g;
      g = _e({
        values: y,
        newValue: g,
        index: V
      }), p && a || (V = g.indexOf(le), ie.current = V);
    }
    return {
      newValue: g,
      activeIndex: V
    };
  }, B = Fe((t) => {
    const a = he(t, M);
    if (!a)
      return;
    if (ee.current += 1, t.type === "mousemove" && t.buttons === 0) {
      K(t);
      return;
    }
    const {
      newValue: o,
      activeIndex: l
    } = _({
      finger: a,
      move: !0
    });
    ye({
      sliderRef: T,
      activeIndex: l,
      setActive: Z
    }), F(o), !de && ee.current > ft && me(!0), c && !ke(o, O) && c(t, o, l);
  }), K = Fe((t) => {
    const a = he(t, M);
    if (me(!1), !a)
      return;
    const {
      newValue: o
    } = _({
      finger: a,
      move: !0
    });
    Z(-1), t.type === "touchend" && H(-1), Q && Q(t, o), M.current = void 0, b();
  }), G = Fe((t) => {
    if (i)
      return;
    Ge() || t.preventDefault();
    const a = t.changedTouches[0];
    a != null && (M.current = a.identifier);
    const o = he(t, M);
    if (o !== !1) {
      const {
        newValue: f,
        activeIndex: s
      } = _({
        finger: o
      });
      ye({
        sliderRef: T,
        activeIndex: s,
        setActive: Z
      }), F(f), c && !ke(f, O) && c(t, f, s);
    }
    ee.current = 0;
    const l = Se(T.current);
    l.addEventListener("touchmove", B, {
      passive: !0
    }), l.addEventListener("touchend", K, {
      passive: !0
    });
  }), b = S.useCallback(() => {
    const t = Se(T.current);
    t.removeEventListener("mousemove", B), t.removeEventListener("mouseup", K), t.removeEventListener("touchmove", B), t.removeEventListener("touchend", K);
  }, [K, B]);
  S.useEffect(() => {
    const {
      current: t
    } = T;
    return t.addEventListener("touchstart", G, {
      passive: Ge()
    }), () => {
      t.removeEventListener("touchstart", G), b();
    };
  }, [b, G]), S.useEffect(() => {
    i && b();
  }, [i, b]);
  const ze = (t) => (a) => {
    var f;
    if ((f = t.onMouseDown) == null || f.call(t, a), i || a.defaultPrevented || a.button !== 0)
      return;
    a.preventDefault();
    const o = he(a, M);
    if (o !== !1) {
      const {
        newValue: s,
        activeIndex: w
      } = _({
        finger: o
      });
      ye({
        sliderRef: T,
        activeIndex: w,
        setActive: Z
      }), F(s), c && !ke(s, O) && c(a, s, w);
    }
    ee.current = 0;
    const l = Se(T.current);
    l.addEventListener("mousemove", B, {
      passive: !0
    }), l.addEventListener("mouseup", K);
  }, be = Le(u ? y[0] : d, d, h), Pe = Le(y[y.length - 1], d, h) - be, x = (t = {}) => {
    const a = De(t), o = {
      onMouseDown: ze(a || {})
    }, l = {
      ...a,
      ...o
    };
    return {
      ...t,
      ref: k,
      ...l
    };
  }, se = (t) => (a) => {
    var l;
    (l = t.onMouseOver) == null || l.call(t, a);
    const o = Number(a.currentTarget.getAttribute("data-index"));
    H(o);
  }, ge = (t) => (a) => {
    var o;
    (o = t.onMouseLeave) == null || o.call(t, a), H(-1);
  };
  return {
    active: j,
    axis: D,
    axisProps: ht,
    dragging: de,
    focusedThumbIndex: q,
    getHiddenInputProps: (t = {}) => {
      const a = De(t), o = {
        onChange: Ae(a || {}),
        onFocus: te(a || {}),
        onBlur: Re(a || {}),
        onKeyDown: Ie(a || {})
      }, l = {
        ...a,
        ...o
      };
      return {
        tabIndex: pe,
        "aria-labelledby": r,
        "aria-orientation": oe,
        "aria-valuemax": ue(h),
        "aria-valuemin": ue(d),
        name: C,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : e.step ?? void 0,
        disabled: i,
        ...t,
        ...l,
        style: {
          ...ct,
          direction: A ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        }
      };
    },
    getRootProps: x,
    getThumbProps: (t = {}) => {
      const a = De(t), o = {
        onMouseOver: se(a || {}),
        onMouseLeave: ge(a || {})
      };
      return {
        ...t,
        ...a,
        ...o
      };
    },
    marks: U,
    open: Ue,
    range: u,
    rootRef: k,
    trackLeap: Pe,
    trackOffset: be,
    values: y,
    getThumbStyle: (t) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: j !== -1 && j !== t ? "none" : void 0
    })
  };
}
const xt = (e) => !e || !we(e);
function St(e) {
  return ot("MuiSlider", e);
}
const z = dt("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), wt = (e) => {
  const {
    open: r
  } = e;
  return {
    offset: re(r && z.valueLabelOpen),
    circle: z.valueLabelCircle,
    label: z.valueLabelLabel
  };
};
function Lt(e) {
  const {
    children: r,
    className: n,
    value: i
  } = e, p = wt(e);
  return r ? /* @__PURE__ */ S.cloneElement(r, {
    className: re(r.props.className)
  }, /* @__PURE__ */ I.jsxs(S.Fragment, {
    children: [r.props.children, /* @__PURE__ */ I.jsx("span", {
      className: re(p.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ I.jsx("span", {
        className: p.circle,
        children: /* @__PURE__ */ I.jsx("span", {
          className: p.label,
          children: i
        })
      })
    })]
  })) : null;
}
function Je(e) {
  return e;
}
const Ct = J("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: n
    } = e;
    return [r.root, r[`color${X(n.color)}`], n.size !== "medium" && r[`size${X(n.size)}`], n.marked && r.marked, n.orientation === "vertical" && r.vertical, n.track === "inverted" && r.trackInverted, n.track === !1 && r.trackFalse];
  }
})(ae(({
  theme: e
}) => ({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  WebkitTapHighlightColor: "transparent",
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${z.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${z.dragging}`]: {
    [`& .${z.thumb}, & .${z.track}`]: {
      transition: "none"
    }
  },
  variants: [...Object.entries(e.palette).filter(Ye()).map(([r]) => ({
    props: {
      color: r
    },
    style: {
      color: (e.vars || e).palette[r].main
    }
  })), {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: 4,
      width: "100%",
      padding: "13px 0",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0"
      }
    }
  }, {
    props: {
      orientation: "horizontal",
      size: "small"
    },
    style: {
      height: 2
    }
  }, {
    props: {
      orientation: "horizontal",
      marked: !0
    },
    style: {
      marginBottom: 20
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: 4,
      padding: "0 13px",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "0 20px"
      }
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      width: 2
    }
  }, {
    props: {
      orientation: "vertical",
      marked: !0
    },
    style: {
      marginRight: 44
    }
  }]
}))), Tt = J("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, r) => r.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), Rt = J("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, r) => r.track
})(ae(({
  theme: e
}) => ({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  border: "1px solid currentColor",
  backgroundColor: "currentColor",
  transition: e.transitions.create(["left", "width", "bottom", "height"], {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      size: "small"
    },
    style: {
      border: "none"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: !1
    },
    style: {
      display: "none"
    }
  }, ...Object.entries(e.palette).filter(Ye()).map(([r]) => ({
    props: {
      color: r,
      track: "inverted"
    },
    style: {
      ...e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${r}Track`],
        borderColor: e.vars.palette.Slider[`${r}Track`]
      } : {
        backgroundColor: Be(e.palette[r].main, 0.62),
        borderColor: Be(e.palette[r].main, 0.62),
        ...e.applyStyles("dark", {
          backgroundColor: Ke(e.palette[r].main, 0.5)
        }),
        ...e.applyStyles("dark", {
          borderColor: Ke(e.palette[r].main, 0.5)
        })
      }
    }
  }))]
}))), It = J("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, r) => {
    const {
      ownerState: n
    } = e;
    return [r.thumb, r[`thumbColor${X(n.color)}`], n.size !== "medium" && r[`thumbSize${X(n.size)}`]];
  }
})(ae(({
  theme: e
}) => ({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  }),
  "&::before": {
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  },
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&.${z.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      width: 12,
      height: 12,
      "&::before": {
        boxShadow: "none"
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 50%)"
    }
  }, ...Object.entries(e.palette).filter(Ye()).map(([r]) => ({
    props: {
      color: r
    },
    style: {
      [`&:hover, &.${z.focusVisible}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[r].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${We(e.palette[r].main, 0.16)}`
        },
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      [`&.${z.active}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[r].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${We(e.palette[r].main, 0.16)}`
        }
      }
    }
  }))]
}))), At = J(Lt, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, r) => r.valueLabel
})(ae(({
  theme: e
}) => ({
  zIndex: 1,
  whiteSpace: "nowrap",
  ...e.typography.body2,
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${z.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${z.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
}))), zt = J("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => Qe(e) && e !== "markActive",
  overridesResolver: (e, r) => {
    const {
      markActive: n
    } = e;
    return [r.mark, n && r.markActive];
  }
})(ae(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
}))), Pt = J("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => Qe(e) && e !== "markLabelActive",
  overridesResolver: (e, r) => r.markLabel
})(ae(({
  theme: e
}) => ({
  ...e.typography.body2,
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
}))), Mt = (e) => {
  const {
    disabled: r,
    dragging: n,
    marked: i,
    orientation: p,
    track: A,
    classes: L,
    color: h,
    size: d
  } = e, C = {
    root: ["root", r && "disabled", n && "dragging", i && "marked", p === "vertical" && "vertical", A === "inverted" && "trackInverted", A === !1 && "trackFalse", h && `color${X(h)}`, d && `size${X(d)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", r && "disabled", d && `thumbSize${X(d)}`, h && `thumbColor${X(h)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return pt(C, St, L);
}, Nt = ({
  children: e
}) => e, Zt = /* @__PURE__ */ S.forwardRef(function(r, n) {
  const i = ut({
    props: r,
    name: "MuiSlider"
  }), p = nt(), {
    "aria-label": A,
    "aria-valuetext": L,
    "aria-labelledby": h,
    // eslint-disable-next-line react/prop-types
    component: d = "span",
    components: C = {},
    componentsProps: P = {},
    color: Q = "primary",
    classes: oe,
    className: Ce,
    disableSwap: ue = !1,
    disabled: N = !1,
    getAriaLabel: ne,
    getAriaValueText: pe,
    marks: Te = !1,
    max: M = 100,
    min: j = 0,
    name: Z,
    onChange: Ue,
    onChangeCommitted: H,
    orientation: de = "horizontal",
    shiftStep: me = 10,
    size: ee = "medium",
    step: O = 1,
    scale: F = Je,
    slotProps: c,
    slots: u,
    tabIndex: y,
    track: U = "normal",
    value: E,
    valueLabelDisplay: q = "off",
    valueLabelFormat: $ = Je,
    ...T
  } = i, k = {
    ...i,
    isRtl: p,
    max: M,
    min: j,
    classes: oe,
    disabled: N,
    disableSwap: ue,
    orientation: de,
    marks: Te,
    color: Q,
    size: ee,
    step: O,
    shiftStep: me,
    scale: F,
    track: U,
    valueLabelDisplay: q,
    valueLabelFormat: $
  }, {
    axisProps: te,
    getRootProps: Re,
    getHiddenInputProps: fe,
    getThumbProps: Ie,
    open: Ae,
    active: ie,
    axis: D,
    focusedThumbIndex: _,
    range: B,
    dragging: K,
    marks: G,
    values: b,
    trackOffset: ze,
    trackLeap: be,
    getThumbStyle: Pe
  } = kt({
    ...k,
    rootRef: n
  });
  k.marked = G.length > 0 && G.some((m) => m.label), k.dragging = K, k.focusedThumbIndex = _;
  const x = Mt(k), se = (u == null ? void 0 : u.root) ?? C.Root ?? Ct, ge = (u == null ? void 0 : u.rail) ?? C.Rail ?? Tt, Me = (u == null ? void 0 : u.track) ?? C.Track ?? Rt, Ne = (u == null ? void 0 : u.thumb) ?? C.Thumb ?? It, Ee = (u == null ? void 0 : u.valueLabel) ?? C.ValueLabel ?? At, t = (u == null ? void 0 : u.mark) ?? C.Mark ?? zt, a = (u == null ? void 0 : u.markLabel) ?? C.MarkLabel ?? Pt, o = (u == null ? void 0 : u.input) ?? C.Input ?? "input", l = (c == null ? void 0 : c.root) ?? P.root, f = (c == null ? void 0 : c.rail) ?? P.rail, s = (c == null ? void 0 : c.track) ?? P.track, w = (c == null ? void 0 : c.thumb) ?? P.thumb, R = (c == null ? void 0 : c.valueLabel) ?? P.valueLabel, g = (c == null ? void 0 : c.mark) ?? P.mark, V = (c == null ? void 0 : c.markLabel) ?? P.markLabel, le = (c == null ? void 0 : c.input) ?? P.input, He = W({
    elementType: se,
    getSlotProps: Re,
    externalSlotProps: l,
    externalForwardedProps: T,
    additionalProps: {
      ...xt(se) && {
        as: d
      }
    },
    ownerState: {
      ...k,
      ...l == null ? void 0 : l.ownerState
    },
    className: [x.root, Ce]
  }), et = W({
    elementType: ge,
    externalSlotProps: f,
    ownerState: k,
    className: x.rail
  }), tt = W({
    elementType: Me,
    externalSlotProps: s,
    additionalProps: {
      style: {
        ...te[D].offset(ze),
        ...te[D].leap(be)
      }
    },
    ownerState: {
      ...k,
      ...s == null ? void 0 : s.ownerState
    },
    className: x.track
  }), $e = W({
    elementType: Ne,
    getSlotProps: Ie,
    externalSlotProps: w,
    ownerState: {
      ...k,
      ...w == null ? void 0 : w.ownerState
    },
    className: x.thumb
  }), rt = W({
    elementType: Ee,
    externalSlotProps: R,
    ownerState: {
      ...k,
      ...R == null ? void 0 : R.ownerState
    },
    className: x.valueLabel
  }), Ve = W({
    elementType: t,
    externalSlotProps: g,
    ownerState: k,
    className: x.mark
  }), je = W({
    elementType: a,
    externalSlotProps: V,
    ownerState: k,
    className: x.markLabel
  }), at = W({
    elementType: o,
    getSlotProps: fe,
    externalSlotProps: le,
    ownerState: k
  });
  return /* @__PURE__ */ I.jsxs(se, {
    ...He,
    children: [/* @__PURE__ */ I.jsx(ge, {
      ...et
    }), /* @__PURE__ */ I.jsx(Me, {
      ...tt
    }), G.filter((m) => m.value >= j && m.value <= M).map((m, v) => {
      const Oe = Le(m.value, j, M), ve = te[D].offset(Oe);
      let Y;
      return U === !1 ? Y = b.includes(m.value) : Y = U === "normal" && (B ? m.value >= b[0] && m.value <= b[b.length - 1] : m.value <= b[0]) || U === "inverted" && (B ? m.value <= b[0] || m.value >= b[b.length - 1] : m.value >= b[0]), /* @__PURE__ */ I.jsxs(S.Fragment, {
        children: [/* @__PURE__ */ I.jsx(t, {
          "data-index": v,
          ...Ve,
          ...!we(t) && {
            markActive: Y
          },
          style: {
            ...ve,
            ...Ve.style
          },
          className: re(Ve.className, Y && x.markActive)
        }), m.label != null ? /* @__PURE__ */ I.jsx(a, {
          "aria-hidden": !0,
          "data-index": v,
          ...je,
          ...!we(a) && {
            markLabelActive: Y
          },
          style: {
            ...ve,
            ...je.style
          },
          className: re(x.markLabel, je.className, Y && x.markLabelActive),
          children: m.label
        }) : null]
      }, v);
    }), b.map((m, v) => {
      const Oe = Le(m, j, M), ve = te[D].offset(Oe), Y = q === "off" ? Nt : Ee;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ I.jsx(Y, {
          ...!we(Y) && {
            valueLabelFormat: $,
            valueLabelDisplay: q,
            value: typeof $ == "function" ? $(F(m), v) : $,
            index: v,
            open: Ae === v || ie === v || q === "on",
            disabled: N
          },
          ...rt,
          children: /* @__PURE__ */ I.jsx(Ne, {
            "data-index": v,
            ...$e,
            className: re(x.thumb, $e.className, ie === v && x.active, _ === v && x.focusVisible),
            style: {
              ...ve,
              ...Pe(v),
              ...$e.style
            },
            children: /* @__PURE__ */ I.jsx(o, {
              "data-index": v,
              "aria-label": ne ? ne(v) : A,
              "aria-valuenow": F(m),
              "aria-labelledby": h,
              "aria-valuetext": pe ? pe(F(m), v) : L,
              value: b[v],
              ...at
            })
          })
        }, v)
      );
    })]
  });
});
export {
  Zt as S
};
//# sourceMappingURL=Slider-CwXiUmiw.mjs.map
